import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button.tsx';
import { cn } from '@/lib/utils.ts';

export type SubmitButtonProps = {
  label?: string;
  isPending?: boolean;
  disabled?: boolean;
  className?: string;
  onClick?: () => void;
};

export default function SubmitButton({
  label = 'Guardar',
  isPending = false,
  disabled,
  className = undefined,
  onClick,
}: SubmitButtonProps) {
  return (
    <Button type="submit" disabled={disabled ?? isPending} className={cn(className)} onClick={onClick}>
      {isPending && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
      {label}
    </Button>
  );
}
